import { useTranslation } from 'next-i18next';
import { ReactElement } from 'react';
import * as React from 'react';

import 'react-datepicker/dist/react-datepicker.min.css';

import { Typography } from '@/shared/components/atoms';

export default function ComingSoon(): ReactElement {
  const { t } = useTranslation('common');
  return (
    <div className='flex h-343 w-full  items-center justify-center duration-700 ease-in hover:scale-150 '>
      <Typography variant='h1' weight='bold' className='mt-24'>
        {t('coming-soon')} ...
      </Typography>
    </div>
  );
}
